
export const UserStoreKey = 'www_um';

export const getUserFromWindow = () => typeof window !== 'undefined' && window[UserStoreKey];

export const attachUserToWindow = (user) => {
    if (typeof window === 'undefined') return;
    window[UserStoreKey] = user;
};
